// import node module libraries
import { Col, Container, Row } from "react-bootstrap";
import {
  CalculatorFill,
  CloudFill,
  LightningChargeFill,
  WrenchAdjustable,
} from "react-bootstrap-icons";
import Image from "react-bootstrap/Image";

// import media files
import dash from "assets/images/hero/dshbrdGasinador.png";

// import custom components
import FeatureTopIcon2 from "components/marketing/common/features/FeatureTopIcon2";
import SectionHeadingLeft2 from "components/marketing/common/section-headings/SectionHeadingLeft2";

const Features2Columns = () => {
  const features = [
    {
      id: 1,
      icon: <CalculatorFill />,
      title: "Vende al precio IDEAL para maximizar tu utilidad",
      description: `Calcula el precio óptimo de venta de tus combustibles con nuestro algorítmo + IA basado en datos reales de costos, competencia y demanda del mercado, para que puedas maximizar tu utilidad al máximo.`,
    },
    {
      id: 2,
      icon: <WrenchAdjustable />,
      title: "Implementación fácil y soporte técnico completo",
      description: `Nuestro equipo de expertos te guiará en cada paso del proceso de implementación, asegurando una transición sin problemas y brindándote soporte técnico continuo para resolver cualquier duda o problema que puedas tener.`,
    },
    {
      id: 3,
      icon: <CloudFill />,
      title: "Accede fácilmente desde cualquier lugar",
      description: `Con nuestra plataforma basada en la nube, puedes acceder a tus datos y reportes desde cualquier lugar y en cualquier momento, facilitando la toma de decisiones informadas para tu negocio.`,
    },
    {
      id: 4,
      icon: <LightningChargeFill />,
      title: "Eficiente y automático",
      description: `Olvídate de procesos manuales y repetitivos. Nuestra plataforma automatiza tareas clave, ahorrándote tiempo y reduciendo errores, para que puedas enfocarte en lo que realmente importa: hacer crecer tu negocio.`,
    },
  ];

  return (
    <section className="pb-8 pb-lg-12 bg-white">
      <Container>
        <div className="text-center mb-5 d-flex justify-content-center align-items-center">
          <Image src={dash} alt="" className="mb-5 w-100" style={{ maxWidth: "30rem" }} />
        </div>
        <Row>
          <Col xl={{ offset: 2, span: 8 }} sm={12}>
            <Row>
              <Col lg={9} md={12} sm={12} className="mb-8">
                {/*  Section left heading */}
                <SectionHeadingLeft2
                  title="Software sencillo y poderoso, desde tu celular o computadora."
                  description="Todo lo que necesitas, personaliza y extiende según tu necesidad."
                />
              </Col>
            </Row>
            <Row>
              <Col lg={12} md={12} sm={12}>
                <Row>
                  {features.map((item, index) => {
                    return (
                      <Col key={index} md={6} sm={12} className="pe-lg-6 mb-lg-6 mb-4">
                        <FeatureTopIcon2 item={item} />
                      </Col>
                    );
                  })}
                </Row>
              </Col>
            </Row>
            {/* <hr className="mt-6" /> */}
          </Col>
        </Row>
      </Container>
    </section>
  );
};
export default Features2Columns;
